export const API = import.meta.env.VITE_API_URL || ''; // Access the environment variable
export const ENV = import.meta.env.VITE_ENV!;

let url = ""
if(import.meta.env.VITE_PUBLIC_URL != null){
    url = import.meta.env.VITE_PUBLIC_URL;
}else{
    url = ENV === "development" ? '/dev' : '';
}
export const PUBLIC_URL = url;
export const HOST = import.meta.env.VITE_HOST;
export const PADDLE_CLIENT_TOKEN = import.meta.env.VITE_PADDLE_CLIENT_TOKEN!;
// PostHog project API key (public, write-only). Analytics is off when it's empty.
export const POSTHOG_KEY: string = import.meta.env.VITE_POSTHOG_PROJECT_TOKEN || import.meta.env.VITE_POSTHOG_KEY || '';
// Browser events go through the first-party reverse proxy. ui_host stays on the EU app
// so toolbar and recording links still resolve when api_host is the proxy.
export const POSTHOG_HOST: string = import.meta.env.VITE_POSTHOG_HOST || 'https://it.calensync.live';
export const POSTHOG_UI_HOST = 'https://eu.posthog.com';

export default API